import { take } from '@redux-saga/core/effects';
import ActionTypes from './constants';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { put, select } from 'redux-saga/effects';
import { makeSelectLastHistoryCabinet } from 'containers/Configurator/selectors/history';
import { makeSelectShelvesLevelSelected } from 'containers/Configurator/selectors/selection';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import { updateCabinetSuccess } from 'containers/Configurator/actions/furniture';
import { Furniture } from 'lib/modelBuilder/entities/Furniture';
import {
  makeSelectFurniture,
  makeSelectSelectedIdCabinet,
} from 'containers/Configurator/selectors/furniture';
import { PositionAngle } from 'lib/modelBuilder/constants';

export default function* openDoorsSaga() {
  while (true) {
    const { payload } = yield take(ActionTypes.OPEN_DOORS);
    // eslint-disable-next-line prefer-const
    let { value, positions } = payload;

    if (!positions) {
      positions = [PositionAngle.FrontRight, PositionAngle.BackLeft];
    }

    const furniture: Furniture | null = yield select(makeSelectFurniture());
    const selectedIdCabinet: string | null = yield select(
      makeSelectSelectedIdCabinet(),
    );

    if (furniture) {
      const newFurniture = furniture.clone();
      if (selectedIdCabinet === null) {
        for (const cabinetEntry of furniture.cabinets) {
          const cabinet = cabinetEntry.cabinet;
          const cabinetNext = cabinet.clone();
          for (const shelf of cabinetNext.shelves) {
            for (const position of Object.values(
              positions as PositionAngle[],
            )) {
              const door = shelf.getDoor(position);
              if (door) door.open = value;
            }
          }
          newFurniture.replace(cabinetNext, cabinetEntry.cabinet.id);
        }
      } else {
        const cabinetOrigin: Cabinet = yield select(
          makeSelectLastHistoryCabinet(),
        );
        const cabinetNext = cabinetOrigin.clone();
        const shelvesLevelSelected: number[] = yield select(
          makeSelectShelvesLevelSelected(),
        );
        let selectedShelves: Shelf[] = [];
        if (shelvesLevelSelected.length === 0)
          selectedShelves = cabinetNext.shelves;
        else
          selectedShelves = cabinetNext.shelves.filter(item =>
            shelvesLevelSelected.includes(item.level),
          );

        for (const shelf of selectedShelves) {
          for (const position of Object.values(positions as PositionAngle[])) {
            const door = shelf.getDoor(position);
            if (door) door.open = value;
          }
        }

        newFurniture.replace(cabinetNext, selectedIdCabinet);
      }
      yield put(
        updateCabinetSuccess(
          newFurniture,
          selectedIdCabinet,
          false,
          undefined,
          false,
        ),
      );
    }
  }
}
